import React from "react";
import Textbox from "../../../components/Textbox";
import CheckBox from "../../../components/Checkbox/Checkbox";

const CleanDataBaseForm = (props: any) => {
  const { values, handleChange, errors, touched } = props;
  return (
    <div>
      <div className="subtitle clearfix">
        <h2 className="title2">Hard Delete Shop Wizard</h2>
      </div>
      <div className="row">
        <div className="col-md-12">
          <Textbox
            name="admin_email"
            placeholder="jone@gmail.com"
            value={values.admin_email}
            onChange={handleChange}
            label="Enter Admin Email"
            errorMessage={touched.admin_email && errors.admin_email}
          />
        </div>
        <div className="col-md-12">
          <Textbox
            name="admin_password"
            placeholder="123456"
            value={values.admin_password}
            onChange={handleChange}
            type="password"
            label="Enter Admin Password"
            errorMessage={touched.admin_password && errors.admin_password}
          />
        </div>
        <div className="col-md-12">
          <Textbox
            name="username"
            placeholder="sachin_tyrnow"
            value={values.username}
            onChange={handleChange}
            label="Enter From Shop username"
            errorMessage={touched.username && errors.username}
          />
        </div>
      </div>
    </div>
  );
};

export default CleanDataBaseForm;
